import { TDROPDOWN_PROPS, TNAV_LINK_STRUCTURE } from '../types';
import { DropdownHeading } from './DropdownHeading';
import { NavLink } from './NavLink';

export const GeneralColDropdownMobile = ({
  activeState,
  topMenu,
  dropdownList,
}: TDROPDOWN_PROPS): JSX.Element => {
  if (!dropdownList) return <div></div>;
  return (
    <div
      className={` ${activeState ? '' : 'hidden'} ${
        topMenu ? ' absolute ' : ''
      } origin-top-right w-full left-0 rounded-md z-10 focus:outline-none overflow-auto sm:overflow-y-scroll max-h-viewport-75`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
    >
      <div className="bg-white">
        <div className="flex flex-wrap">
          {dropdownList.map((ele: TNAV_LINK_STRUCTURE, index) => (
            <div
              className={`w-full px-4 py-3 ${
                ele.bgColor ? 'bg-[#F4F9FF]' : 'bg-white'
              }
              ${ele.order ? `order-${ele.order} ` : 0}
                `}
              key={`title_${index}_${ele.name}`}
            >
              <DropdownHeading name={ele.name} />

              {ele.child.map((item) => {
                return (
                  <NavLink key={item.title} childEle={item} parentEle={ele} />
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
